import React from 'react';
import PublicChat from '../../../components/PublicChat/PublicChat';
import Mailbox from '../../../components/Mailbox/Mailbox';

const AluminiCommunication = ({ inboxSubsection }) => {
  return (
    <div className="min-h-screen bg-slate-50 p-3 md:p-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl font-bold text-slate-900 md:text-3xl">Communication</h1>
          <p className="mt-2 text-sm text-slate-600 md:text-base">
            Connect with mentors, peers, and the community
          </p>
        </div>

        <div className="rounded-xl border border-slate-100 bg-white shadow-sm">
          {inboxSubsection === 'public' ? <PublicChat /> : <Mailbox />}
        </div>
      </div>
    </div>
  );
};

export default AluminiCommunication;
